import "@grapecity/wijmo.cultures/wijmo.culture.el";
import "@grapecity/wijmo.styles/wijmo.css";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "src/assets/scss/style.scss";
import { persistor, store } from "src/store/store";
import App from "./App.jsx";
import { PermissionProvider } from "./context/permissionContenxt.jsx";
import i18n from "./i18n/index.js";

ReactDOM.createRoot(document.getElementById("root")).render(
  <I18nextProvider i18n={i18n}>
    <SnackbarProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <PermissionProvider>
            <BrowserRouter basename="/lae-miteres">
              <App />
            </BrowserRouter>
          </PermissionProvider>
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  </I18nextProvider>,
);
